'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _authService = require('../../../auth/authService');

exports.default = function (config) {
    var token = (0, _authService.getCurrentUserToken)();
    if (token) {
        config.headers.Authorization = 'Bearer ' + token;
    }
    return config;
}; // Services


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/requestAuthorisationInterceptor.js
// module id = 2134
// module chunks = 0